<template>
  <div v-if="user">
    <div class="chain-user-index" v-if="user.chain_state==1">
      <div class="user-header">
        <div class="info-wrapper">
          <div class="right">
            <span class="iconfont btn-exit" @click="logout">&#xe688;</span>
            <div><span class="user-name">{{user.chain_addressname}}</span></div>
            <div><span class="user-phone">{{user.chain_address}}</span></div>
          </div>
        </div>

      </div>
      <div class="chain-menu">
        <mt-cell class="menu-item mt-10"
                 title="Order management"
                 :to="{name:'ChainOrderList'}"
                 is-link>
          <span slot="icon" class="left-icon iconfont">&#xe660;</span>
        </mt-cell>
        <mt-cell v-if="info.store_id" class="menu-item"
                 title="Inventory management"
                 :to="{name:'ChainGoodsList'}"
                 is-link>
          <span slot="icon" class="left-icon iconfont">&#xe6e7;</span>
        </mt-cell>
        <mt-cell class="menu-item"
                 title="Store settings"
                 :to="{name:'ChainSetting'}"
                 is-link>
          <span slot="icon" class="left-icon iconfont">&#xe607;</span>
        </mt-cell>
        <div @click="showPassword=true">
          <mt-cell class="menu-item"
                   title="Change password"
                   is-link>
            <span slot="icon" class="left-icon iconfont">&#xe623;</span>
          </mt-cell>
        </div>
      </div>
      <mt-popup v-model="showPassword" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="Change password" class="common-header">
            <mt-button slot="left" icon="back" @click="showPassword=false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <mt-field label="Old password" type="password" v-model="passowrdData.old_password"></mt-field>
          <mt-field label="New password" type="password" v-model="passowrdData.password"></mt-field>
          <mt-field label="Confirm password" type="password" v-model="passowrdData.passwd_confirm"></mt-field>
          <mt-button size="large" type="primary" @click="submit" class="ds-button-large mt-10">submit</mt-button>
        </div>
      </mt-popup>
    </div>
    <div v-else>
      <div class="common-header-wrap">
        <mt-header title="Collection point to join" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>
      <div class="wait-wrapper">
        <img class="wait-img" src="../../../assets/image/wait_verify.png" />
        <div class="message" v-if="user.chain_state==10">
          Please wait for the administrator to review
        </div>
        <div class="message" v-if="user.chain_state==0">
          Collection point is closed
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { chainLogout, chainChangePassword, chainInformation } from '../../../api/chainManage'
export default {
  name: 'ChainUser',
  data () {
    return {
      showSetting: false,
      showPassword: false,
      passowrdData: {},
      info:{}
    }
  },
  created: function () {
    if (!this.user) {
      this.$router.push({ name: 'ChainLogin' })
    } else {
      // if (this.user.invalid_time < parseInt((new Date().getTime()) / 1000)) { // 重新拉取信息
      chainInformation().then(res => {
        let info = res.result.chain_info
        this.info=info
        this.chainUpdate({ info: res.result.info })
        if (info.chain_state == 20) {
          Toast('Audit not passed:' + info.chain_failreason)
          this.$router.push({ name: 'ChainRegister' })
        }
      }).catch(function (error) {
        Toast(error.message)
      })
      // }
    }
  },
  methods: {
    ...mapMutations({
      chainUpdate: 'chainUpdate',
      chainLogout: 'chainLogout'
    }),
    submit () {
      chainChangePassword(this.passowrdData).then(res => {
        Toast(res.message)
        this.showPassword = false
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    logout () {
      chainLogout().then(res => {
        this.chainLogout()
        this.$router.push({ name: 'ChainLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.chain.info,
      token: state => state.member.token
    })
  }

}
</script>
<style  lang="scss" scoped>
  .chain-user-index{
    .user-header{background:$primaryColor;color:#fff;font-size:.8rem;
      .info-wrapper{padding:1rem .5rem;display:flex;
        .right{flex:1;line-height:1;
          .user-name{font-size:.8rem;line-height:1rem;}
          .common-score-wrapper{margin-left:.2rem}
          .user-phone{font-size:.6rem;opacity:.8;}
          .btn-exit{float:right;font-size:1rem;opacity: .8;}
        }
      }
    }
    .chain-menu{
      .menu-item{border-bottom:1px solid #eee;
        &::after{background: none}
        .left-icon{font-size:1rem;vertical-align:middle}
      }
    }
  }
  .wait-wrapper{margin-top:5rem;text-align: center}
  .wait-wrapper .wait-img{width:13rem;}
  .wait-wrapper .message{font-size:.7rem;}
</style>
